/**
 * Known farm property metadata keyed by region slug.
 * Address is not stored on the region API yet, so public listings and map
 * summary panels share this lookup for seeded farms.
 */
export const FARM_REGION_ADDRESSES: Readonly<Record<string, string>> = {
  'circle-t-farm': '99 Gunbower Pyramid Road, Gunbower VIC 3566',
};

export type RegionKind = 'council' | 'farm';

/** Classify a civic region as farm vs council for map layers and listings. */
export function resolveRegionKind(
  slug: string,
  name: string,
  tenantType: string | undefined,
  tenantSlug: string | undefined,
): RegionKind {
  if (/farm/i.test(slug) || /farm/i.test(name)) return 'farm';
  if (tenantSlug === 'circle-t') return 'farm';
  // Non-council property owners render on the farm boundary layer.
  if (tenantType === 'service_provider' && tenantSlug !== 'yv-water') return 'farm';
  return 'council';
}

export function getFarmAddress(regionSlug: string | undefined | null): string | undefined {
  if (!regionSlug) return undefined;
  return FARM_REGION_ADDRESSES[regionSlug];
}
